import { Button, Card, Modal } from "antd";
import React from 'react';
import OtpInput from 'react-otp-input';
import './OtpModal.css';

const OtpModal: React.FC<{
    otp: string;
    setOtp: React.Dispatch<React.SetStateAction<string>>;
    open: boolean;
    confirmLoading: boolean;
    handleOk: () => void;
    handleCancel: () => void;
}> = ({ otp, setOtp, open, confirmLoading, handleOk, handleCancel }) => {

    return (
        <Modal width={520} className="otp-modal" title="Please enter code from the authenticator app" open={open} confirmLoading={confirmLoading} onCancel={handleCancel} footer={null}>
        <Card className="otp-modal-container">
            <OtpInput inputStyle={{
                height: 40,
                width: 40,
                marginBlock: 12
            }} value={otp} onChange={setOtp} numInputs={6} renderSeparator={<span style={{
                marginInline: 8
            }}>-</span>} inputType="number" renderInput={props => <input {...props} />} />
            <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                marginBlock: 10
            }}>
                <Button style={{
                    marginRight: 8,
                    marginBottom: 10
                }} onClick={handleCancel}>Cancel</Button>
                <Button loading={confirmLoading} onClick={handleOk} type="primary">Verify</Button>
            </div>
            
        </Card>

        </Modal>
    )
}

export default OtpModal